import { motion } from "framer-motion";

const BACKERS = [
  {
    name: "Y Combinator",
    short: "YC",
    color: "#FF6600",
    desc: "Backed startups",
  },
  {
    name: "Andreessen Horowitz",
    short: "a16z",
    color: "#2D2D2D",
    desc: "Portfolio apps",
  },
  {
    name: "Antler",
    short: "Antler",
    color: "#000000",
    desc: "Founder cohorts",
  },
  {
    name: "Techstars",
    short: "Techstars",
    color: "#009900",
    desc: "Accelerator grads",
  },
  {
    name: "500 Global",
    short: "500",
    color: "#E91E8C",
    desc: "Global portfolio",
  },
  {
    name: "Sequoia",
    short: "Sequoia",
    color: "#A0522D",
    desc: "Seed & Series A",
  },
  {
    name: "Lightspeed",
    short: "LSVP",
    color: "#6C3CE1",
    desc: "Venture portfolio",
  },
  {
    name: "Tiger Global",
    short: "Tiger",
    color: "#1A1A2E",
    desc: "Growth stage",
  },
];

export default function TrustedByBackers() {
  return (
    <section
      className="py-16 md:py-20 bg-charcoal overflow-hidden"
      data-testid="trusted-backers-section"
    >
      <div className="container">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <p className="text-overline text-electric mb-3">Social Proof</p>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white">
            Trusted by startups backed by the{" "}
            <span className="relative inline-block">
              <span className="relative z-10">world's best investors.</span>
              <span className="absolute inset-x-0 bottom-1 h-2.5 bg-electric/40 -z-0" />
            </span>
          </h2>
          <p className="mt-4 text-zinc-400 text-lg max-w-2xl mx-auto">
            From YC demo day launches to Series A scale-ups — AppFillip is the
            app marketing partner founders trust when growth really matters.
          </p>
        </motion.div>

        {/* Backer grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {BACKERS.map((backer, idx) => (
            <motion.div
              key={backer.name}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: idx * 0.05 }}
              className="group bg-charcoal hover:bg-white/5 transition-colors p-7 md:p-8 flex flex-col items-center justify-center text-center gap-3"
              data-testid={`backer-${idx}`}
            >
              {/* Logo badge */}
              <div
                className="w-14 h-14 flex items-center justify-center font-display font-black text-white text-lg"
                style={{ backgroundColor: backer.color }}
              >
                {backer.short.length <= 3 ? (
                  <span className="text-xl">{backer.short}</span>
                ) : (
                  <span className="text-xs leading-tight px-1">
                    {backer.short}
                  </span>
                )}
              </div>
              <div>
                <p className="font-display font-bold text-white text-base leading-tight">
                  {backer.name}
                </p>
                <p className="text-xs text-zinc-500 mt-0.5 uppercase tracking-widest">
                  {backer.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom strip */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8"
        >
          <p className="text-zinc-400 text-sm text-center sm:text-left">
            Our clients have collectively raised{" "}
            <span className="text-white font-semibold">$2B+</span> in venture
            funding — and chose AppFillip to grow their apps.
          </p>
          <a
            href="/case-studies"
            className="inline-flex items-center gap-2 text-electric text-sm font-semibold hover:underline underline-offset-4 whitespace-nowrap"
          >
            Read their stories →
          </a>
        </motion.div>
      </div>
    </section>
  );
}
